import { CognitoUser } from "amazon-cognito-identity-js"
import { Auth } from "aws-amplify"
import { User } from "src/models"
import appsyncApi from "src/services/appsyncApi"

export async function login(payload: { email: string; password: string }): Promise<User> {
  const { email, password } = payload
  const cognitoUser: CognitoUser = await Auth.signIn(email, password)
  if ((cognitoUser as any).challengeName === "NEW_PASSWORD_REQUIRED") {
    await Auth.completeNewPassword(cognitoUser, password)
  }
  return await getProfile()
}

export async function getProfile(): Promise<User> {
  const cognitoUser = await Auth.currentAuthenticatedUser()
  const organizationId = cognitoUser.attributes["custom:org_id"]
  const id = cognitoUser.attributes.sub
  const currentHcpUser = await appsyncApi.getHcpUser({ id })
  const role = currentHcpUser.role ?? undefined
  return {
    email: cognitoUser.attributes.email,
    id,
    name: cognitoUser.attributes.name,
    organizationId,
    NPI: cognitoUser.attributes["custom:npi_number"],
    role
  }
}

export async function logout() {
  await Auth.signOut()
}

type ChangePasswordErrorCode = "LimitExceededException" | "ExpiredCodeException" | "CodeMismatchException"
export type ChangePasswordError = { code: ChangePasswordErrorCode; message: string }
export async function changePassword(payload: { email: string; token: string; password: string }) {
  const { email, token, password } = payload
  await Auth.forgotPasswordSubmit(email, token, password)
  return
}

type ResetPasswordErrorCode = "LimitExceededException" | "UserNotFoundException"
export type ResetPasswordError = { code: ResetPasswordErrorCode; message: string }
export async function resetPassword(payload: { email: string }) {
  await Auth.forgotPassword(payload.email)
}
